module.exports = __webpack_public_path__ + "media/images/global/arrow-right-8830e5ee41aabe0170d366835bec66f9.svg";